import { getLanguage } from './language.utils';

export const downloadBase64Image = (base64Data: string, filename: string) => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'image/jpeg' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;

  a.click();

  URL.revokeObjectURL(url);
};

export const downloadFile = (file: File, filename: string) => {
  const url = URL.createObjectURL(file);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;

  a.click();

  URL.revokeObjectURL(url);
};

export const createFileFromUrl = async (url, fileName) => {
  const response = await fetch(url);
  const blob = await response.blob();
  const file = new File([blob], fileName, { type: blob.type });
  return file;
};

export const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

export const getFileVehiculeImportHeader = () => [
  'Brand',
  'Model',
  'VIN',
  'LicensePlateNumber',
  'YearOfFirstRegistration',
  'Mileage',
  'Comment',
  'Picture',
];

export const getFileLineExampleVehicule = () => [
  'BMW',
  'Serie 3',
  'VF3YB9HP0JT123456',
  'AB-123-CD',
  '2020',
  '35000',
  'Comment',
  'https://images.pexels.com/photos/170811/pexels-photo-170811.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
];

export const downloadTemplateVehiculeImport = () => {
  const headers = getFileVehiculeImportHeader();
  const example = getFileLineExampleVehicule();
  const csv = [headers.join(','), example.join(',')].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', 'import-vehicules-model.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getFileVehiculeCheckRequestImportHeader = () => [
  'InspectionStartDate',
  'VIN',
  'LicensePlateNumber',
  'Brand',
  'Model',
  'Firstname',
  'Lastname',
  'Email',
  'AdditionalEmails',
  'Phone',
  'AddressLine1',
  'AddressLine2',
  'PostalCode',
  'City',
  'Country',
];

export const getFileLineExampleVehiculeCheckRequest = () => {
  const today = new Date();
  const { isFrench } = getLanguage();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();
  const exampleDate = isFrench ? `${dd}-${mm}-${yyyy}` : `${yyyy}-${mm}-${dd}`;
  return [
    exampleDate,
    'VF3YB9HP0JT123456',
    'AB-123-CD',
    'BMW',
    'Serie 3',
    'Jean',
    'Dupont',
    'jean.dupont@example.com',
    '[other@example.com;another@example.com]',
    '+33612345678',
    '1 Rue de la Paix',
    '',
    '75001',
    'Paris',
    'France',
  ];
};

export const downloadTemplateVehiculeCheckRequestImport = () => {
  const headers = getFileVehiculeCheckRequestImportHeader();
  const example = getFileLineExampleVehiculeCheckRequest();
  const csv = [headers.join(','), example.join(',')].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', 'import-inspection-requests-model.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
